/** `step` for HTML number inputs that accept cents. */
export const DECIMAL_INPUT_STEP = '0.01';

/** Format a value for display in a decimal number field (2 places). Empty stays empty. */
export function formatDecimalInputValue(raw: string | number | null | undefined): string {
  if (raw === '' || raw == null) return '';
  const s = String(raw).trim();
  if (s === '') return '';
  const n = Number.parseFloat(s);
  if (!Number.isFinite(n)) return s;
  return n.toFixed(2);
}
